import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, User, Clock } from 'lucide-react';
export function DrSebiHeroSection() {
  return <section className="relative pt-12 pb-8 sm:pt-16 sm:pb-12 bg-bone overflow-hidden" data-id="element-731">
      <div className="max-w-3xl mx-auto px-6 relative z-10" data-id="element-732">
        {/* Category Tag */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="flex justify-center mb-6" data-id="element-733">
          <span className="bg-ginger/10 text-ginger px-4 py-1.5 rounded-full text-xs font-medium tracking-widest uppercase" data-id="element-734">
            Holistic Health
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-charcoal text-center leading-[1.2] mb-6" data-id="element-735">
          10 Reasons Why Dr. Sebi Taught That Ginger-Based Botanicals Restore
          Joint Flow (Not Just Mask Pain)
        </motion.h1>

        {/* Hero Image */}
        <motion.img initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} src="https://cdn.magicpatterns.com/uploads/hAiAeYVz36BXoxHBMVByDy/bc33907b-10e6-48dd-85ef-bb580fd126cf.png" alt="Joint Health & Regeneration - Targeted Therapy" className="w-full mb-8" data-id="element-736" />

        {/* Author Meta */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-charcoal-light/80 border-y border-charcoal/10 py-3" data-id="element-737">
          <div className="flex items-center gap-1.5" data-id="element-738">
            <User className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-739" />
            <span data-id="element-740">By Jerome P</span>
          </div>
          <span className="text-charcoal-light/40" data-id="element-741">•</span>
          <div className="flex items-center gap-1.5" data-id="element-742">
            <Calendar className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-743" />
            <span data-id="element-744">Nov 19, 2025</span>
          </div>
          <span className="text-charcoal-light/40" data-id="element-745">•</span>
          <div className="flex items-center gap-1.5" data-id="element-746">
            <Clock className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-747" />
            <span data-id="element-748">6 min read</span>
          </div>
        </motion.div>

        {/* Intro Text */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="mt-10 prose prose-lg prose-stone mx-auto text-charcoal/90" data-id="element-749">
          <p className="font-medium text-xl leading-relaxed" data-id="element-750">
            Joint stiffness isn't a mystery. And it's not "just aging."
          </p>
          <p className="leading-relaxed" data-id="element-751">
            Dr. Sebi taught something most people never hear:{' '}
            <span className="font-semibold text-ginger" data-id="element-752">
              Pain isn't the problem — stagnation is.
            </span>
          </p>
          <p className="leading-relaxed" data-id="element-753">
            When circulation slows, tissues cool, nutrients can't reach joints,
            and waste can't leave. That's when stiffness, discomfort, and
            limited movement show up.
          </p>
          <p className="leading-relaxed" data-id="element-754">
            Ginext Ginger Oil was designed around this exact principle — using
            warming, penetrating botanicals that restore flow instead of numbing
            sensation.
          </p>
          <p className="font-medium" data-id="element-755">Here's why that matters.</p>
        </motion.div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-full h-32 bg-gradient-to-b from-white to-transparent pointer-events-none" data-id="element-756" />
      <div className="absolute top-20 -right-20 w-64 h-64 bg-ginger/5 rounded-full blur-3xl pointer-events-none" data-id="element-757" />
      <div className="absolute top-40 -left-20 w-64 h-64 bg-herbal/5 rounded-full blur-3xl pointer-events-none" data-id="element-758" />
    </section>;
}